import { Component, OnInit } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { jwtDecode } from 'jwt-decode';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../services/auth.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Client } from '../../../../api/api-reference';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslateModule, BreadcrumbComponent, AngularSvgIconModule, RouterLink, CommonModule, ConfirmDialogComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  name: string = 'User';
  role: string = 'Guest';
  image: string | undefined;
  isProfileOpen=false;
  isLogoutModalOpen=false;
  isSystemStatusOpen=false;
  isNetworkOnline=true;

  constructor(public authService: AuthService, private router: Router, private client: Client){}

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token) as {
        name: string;
        roleName: string;
        image: string;
      };
      this.name = decodedToken.name;
      this.role = decodedToken.roleName;
      this.image = decodedToken.image;
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isProfileOpen = false;
        this.isSystemStatusOpen = false;
      }
    });

    
    this.client.getIpSecStatus()
      .pipe(catchError(() => EMPTY))
      .subscribe(isOnline => this.isNetworkOnline = isOnline);
  }

  toggleProfileModal(){
    this.isProfileOpen=!this.isProfileOpen;
  }

  toggleSystemStatus(){
    this.isSystemStatusOpen=!this.isSystemStatusOpen;
  }

  logOut() {
    this.authService.logout();
  }
}
